module.exports = __webpack_public_path__ + "img/MES5VideoThumbnail.db403362.png";